<template>
  <b-card>
    <luma-datatable  url="support/tickets"
                     :columns="columns"
                     :model="model">
    </luma-datatable>
  </b-card>
</template>

<script>
  import LumaDatatable from "@/components/LumaDatatable"
  import {Tickets} from "@/store/models/support/tickets";

  export default {
        name: "luma-support-list",
    components:{LumaDatatable},
    data:()=>({
      model:Tickets
    }),
    computed:{
      columns(){
        return [
          {
            key: 'user',
            column: 'user',
            filter: false,
            order: true
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/support/list_support/luma-support-list.vue